var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SlideOutV2',{ref:"slideOut",attrs:{"is-loading":_vm.isLoading},on:{"on-submit":_vm.onSubmit}},[_c('OrdersReworkPropertiesUpdate',{ref:"ordersReworkPropertiesUpdate",attrs:{"rework-properties":_vm.propertiesToUpdate,"is-actions-hide":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }